import { Globals } from "../CoreApp/Globals";

export function FinishPostBook() {
  var g = Globals._bookRenderInfo;
  var pp = g.fPubPanel;
  pp.DoPostBook("final");
}
